import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingAddressCardBody = (props) => {
    const {
        businessName,
        lastName,
        firstName,
        address,
        postalCode,
        city,
        country,
        taxId
    } = props;

    const { t: gctrad } = useTranslation();
  
    return (
        <div className="card-body">
            <ul className="m-0 p-0 list-unstyled">
                <li className="mb-3">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire Nom à faire apparaître sur la facture')} : </strong><br/>
                    <span>{businessName}</span></h6>
                </li>
                <li className="mb-2">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire Nom')} : </strong>
                    <span>{lastName}</span></h6>
                </li>
                <li className="mb-3">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire Prénom')} : </strong>
                    <span>{firstName}</span></h6>
                </li>
                <li className="mb-2">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire Adresse de facturation')} : </strong>
                    <span>{address}</span></h6>
                </li>
                <li className="mb-2">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire code postal')} : </strong>
                    <span>{postalCode}</span></h6>
                </li>
                <li className="mb-2">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire ville')} : </strong>
                    <span>{city}</span></h6>
                </li>
                <li className="mb-3">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire Pays')} : </strong>
                    <span>{country}</span></h6>
                </li>
                <li className="m-0">
                    <h6 className="card-subtitle text-muted"><strong>{gctrad('formulaire code nif')} : </strong>
                    <span>{taxId}</span></h6>
                </li>
            </ul>
        </div>
    );
}

export default BillingAddressCardBody;